export default __webpack_public_path__ + "static/GettyImages-1236933621-9694fbcb5c464c8a2c2fd52aae073948.jpg";